import { render, staticRenderFns } from "./ContractProductsExtraTaxesAndIncentives.vue?vue&type=template&id=390008fd&scoped=true&"
import script from "./ContractProductsExtraTaxesAndIncentives.vue?vue&type=script&lang=js&"
export * from "./ContractProductsExtraTaxesAndIncentives.vue?vue&type=script&lang=js&"
import style0 from "./ContractProductsExtraTaxesAndIncentives.vue?vue&type=style&index=0&id=390008fd&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390008fd",
  null
  
)

export default component.exports